import React from 'react';

function LockedMessage({ message }) {
  return (
    <div className="alert alert-warning" role="alert">
      <h4 className="alert-heading">
        <i className="bi bi-lock me-2"></i>
        Formular nicht verfügbar
      </h4>
      <p className="mb-0">{message || 'Das Bestellformular ist derzeit nicht verfügbar.'}</p>
    </div>
  );
}

export default LockedMessage;
